import { useState } from "react";
import { Box, Typography, TextField, Button, Grid, Alert } from "@mui/material";
import { defaultStyle } from "components/Modals";
import { createGOGroup } from "api/resources/go";
import { FormErrorProps } from "api/models/FormErrorProps";

interface NewOperatorModalProps {
  dispatch: any;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewOperatorModal = ({
  dispatch,
  setOpenModal,
}: NewOperatorModalProps) => {
  const [formErrors, setFormErrors] = useState(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const groupData = {
      name: data.get("name"),
    };

    createGOGroup(groupData)
      .then(() => {
        setOpenModal(false);
        dispatch();
      })
      .catch((error) => {
        console.log(error);
        setFormErrors(error.response.data.errors);
      });
  };

  return (
    <Box sx={defaultStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h5">
        Create a new group
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2} sx={{ mt: "1rem", mb: "2rem" }}>
          <Grid item sm={12}>
            <TextField
              id="name"
              name="name"
              label="Name"
              size="small"
              required
              sx={{ width: "100%" }}
            />
          </Grid>
          {formErrors && (
            <Grid item sm={12}>
              {formErrors.map(({ message }: FormErrorProps) => (
                <Alert variant="filled" severity="error" sx={{ mb: "0.4rem" }}>
                  {message}
                </Alert>
              ))}
            </Grid>
          )}
          <Grid item sm={12} sx={{ mt: "1rem" }}>
            <Button variant="contained" type="submit">
              Create group
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default NewOperatorModal;
